module.exports = __webpack_public_path__ + "static/logo-beb7af7d8b34fab4dbedcc19ca012cdd.svg";